import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { ExternalLink } from 'lucide-react';
import { Document, Page, pdfjs } from 'react-pdf';

// Worker servito dalla stessa app (public/): affidabile sia in dev che nel build di produzione
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

const isMobile = /Android|iPhone|iPad|iPod/i.test(typeof navigator !== 'undefined' ? navigator.userAgent : '');

/** Anteprima PDF: iframe nativo su desktop, pdf.js su mobile, fallback "apri in nuova scheda". */
export default function PdfPreviewDialog({ open, url, onClose }) {
  const [numPages, setNumPages] = useState(null);
  const [canvasError, setCanvasError] = useState(false);
  const pageWidth = Math.min((typeof window !== 'undefined' ? window.innerWidth : 900) - 48, 850);

  const apriNuovaScheda = () => {
    if (url) window.open(url, '_blank');
  };

  const handleChange = (o) => {
    if (!o) {
      setNumPages(null);
      setCanvasError(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleChange}>
      <DialogContent className="max-w-[98vw] sm:max-w-4xl h-[92vh] rounded-md p-0 flex flex-col gap-0">
        <DialogHeader className="p-3 border-b border-border">
          <div className="flex items-center justify-between gap-2 pr-8">
            <DialogTitle className="font-mono uppercase tracking-wider text-sm">Anteprima Documento</DialogTitle>
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="rounded-md h-8 text-xs"
              onClick={apriNuovaScheda}
              data-testid="pdf-apri-scheda-btn"
            >
              <ExternalLink className="h-3.5 w-3.5 mr-1.5" />
              Apri in nuova scheda
            </Button>
          </div>
        </DialogHeader>
        <div className="flex-1 overflow-auto bg-muted/40" data-testid="pdf-preview-scroll">
          {url && !isMobile && !canvasError && (
            <iframe src={url} title="Anteprima PDF" className="w-full h-full border-0" data-testid="pdf-iframe" />
          )}
          {url && isMobile && !canvasError && (
            <div className="py-2">
              <Document
                file={url}
                onLoadSuccess={({ numPages: n }) => setNumPages(n)}
                onLoadError={(e) => { console.error('Errore caricamento PDF:', e); setCanvasError(true); }}
                loading={<p className="text-center text-sm text-muted-foreground py-10">Caricamento PDF…</p>}
                error={null}
              >
                {Array.from({ length: numPages || 0 }, (_, i) => (
                  <Page
                    key={i}
                    pageNumber={i + 1}
                    width={pageWidth}
                    className="mx-auto mb-3 shadow-md"
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                ))}
              </Document>
            </div>
          )}
          {url && canvasError && (
            <div className="flex flex-col items-center justify-center h-full gap-4 p-6 text-center" data-testid="pdf-fallback">
              <p className="text-sm text-muted-foreground">
                L'anteprima integrata non è supportata su questo dispositivo.
              </p>
              <Button onClick={apriNuovaScheda} className="rounded-md" data-testid="pdf-fallback-apri">
                <ExternalLink className="h-4 w-4 mr-2" />
                Apri il PDF in una nuova scheda
              </Button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
